export const SVGIconProperties = {
	facialFeatureColor: '#333300',
	//outlineColor: '#f29700'
	outlineColor: '#b27700'
}
